import { KEY_VERSION } from '@/constants/api-source-types';
import { API2_HOST } from '@/utils/constants';

import fetchData from './http';
import request from './request';
import { IBaseResponse, IResult } from './types/common';
import { IVerifySubParms, IWholeMobileAndEmailResult } from './types/verify';
// 验证谷歌验证码
export function verifyGoogle2fa(verification_code: string) {
  const url = `${API2_HOST}/verify/google2fa`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, {
        body: JSON.stringify({ verification_code }),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 手机号和邮箱脱敏
export function getWholeMobileOrEmail(params: { [key: string]: boolean }) {
  const url = `${API2_HOST}/v3/private/user/member/user-info`;
  return new Promise((resolve, reject) => {
    request
      .post<IBaseResponse<IWholeMobileAndEmailResult>>(url, {
        body: JSON.stringify(params),
        useCache: true,
        ttl: 60 * 1000,
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 发送短信验证码
export function sendMobile(country_code: string, mobile: string, from: string) {
  const url = `${API2_HOST}/send/mobile`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, {
        body: JSON.stringify({ country_code, mobile, from }),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 发送短信验证码 有行为验证
export function sendCodeMobile(params: { [key: string]: any }) {
  params.key_version = KEY_VERSION;
  const url = `${API2_HOST}/sendcode/mobile`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, { body: JSON.stringify(params) })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 发送邮箱验证码
export function email(
  email: string,
  type: string,
  captchaData: { [key: string]: string },
  cnt: number | undefined,
  from: number,
) {
  const url = `${API2_HOST}/send/email`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, {
        body: JSON.stringify({
          email,
          cnt,
          type,
          from,
          ...captchaData,
          key_version: KEY_VERSION,
        }),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 验证邮箱验证码
export function verifyEmail(
  verification_code: string,
  email: string,
  from: number,
) {
  const url = `${API2_HOST}/verify/email`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, {
        body: JSON.stringify({ verification_code, email, from }),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 手机验证码验证
export function verifyMobile(
  country_code: string,
  verification_code: string,
  from: number,
) {
  // 短信验证
  return new Promise((resolve, reject) => {
    const url = `${API2_HOST}/verify/mobile`;
    fetchData
      .post<IBaseResponse<IResult>>(url, {
        body: JSON.stringify({
          country_code, // 国家代码
          verification_code, // 验证码
          from,
        }),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 获取母账号谷歌验证码绑定所需的信息
export function googlefa() {
  return new Promise((resolve, reject) => {
    const url = `${API2_HOST}/google2fa/info`;
    fetchData
      .get<IBaseResponse<IResult>>(url, {})
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 获取子账号谷歌验证码绑定所需信息
export function googlefa2() {
  return new Promise((resolve, reject) => {
    const url = `${API2_HOST}/v3/private/user/member/google2fa-info`;
    fetchData
      .get<IBaseResponse<IResult>>(url, {})
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 子账号绑定google发送验证码
export function authenticate(params: { [key: string]: any }) {
  return new Promise((resolve, reject) => {
    const url = `${API2_HOST}/v3/private/user/authenticate`;
    fetchData
      .post<IBaseResponse<IResult>>(url, { body: JSON.stringify(params) })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 检查子账号是否可用
export function verifySubmember(params: IVerifySubParms) {
  return new Promise((resolve, reject) => {
    const url = `${API2_HOST}/v3/private/user/member/submember-create-verify`;
    fetchData
      .get(url, { body: JSON.stringify(params) })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

export function bindEmail(
  email: string,
  type: string,
  verification_code: string,
  from: number,
) {
  return new Promise((resolve, reject) => {
    const url = `${API2_HOST}/bind/email`;
    fetchData
      .post<IBaseResponse<IResult>>(url, {
        body: JSON.stringify({
          email, // 邮箱
          type, // 类型
          verification_code, // 邮箱验证码
          from,
        }),
      })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}
